import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { useTranslation, Trans } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShieldHalved } from "@fortawesome/free-solid-svg-icons";
import "./GDPRConsent.scss";

const GDPRConsent = () => {
    const { t, i18n } = useTranslation();
    const [showBanner, setShowBanner] = useState(false);

    useEffect(() => {
        const storedConsent = localStorage.getItem("gdpr_consent");
        if (!storedConsent) {
            setShowBanner(true);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem("gdpr_consent", JSON.stringify({ acknowledged: true, date: new Date().toISOString() }));
        setShowBanner(false);
    };

    if (!showBanner) return null;

    return (
        <div className="gdpr-banner">
            <div className="gdpr-banner__icon"><FontAwesomeIcon icon={faShieldHalved} /></div>
            <p className="gdpr-banner__text">
                <Trans i18nKey="landing.gdpr.text" components={{ 1: <NavLink to={`/${i18n.language}/privacy`} target="_blank" rel="noopener noreferrer" /> }} />
            </p>
            <button className="gdpr-banner__btn" onClick={handleAccept}>
                {t("landing.gdpr.accept")}
            </button>
        </div>
    );
};

export default GDPRConsent;
